import { IDeductionRepository, IGetApprovalsRepositoryParams, IGetApprovalsRepositoryResponse } from "@/core/repositories/deduction";

export class GetApprovalsUseCase {
  constructor(private readonly deductionRepository: IDeductionRepository) {}

  async execute(params: IGetApprovalsRepositoryParams, refetch?: boolean): Promise<IGetApprovalsRepositoryResponse> {
    const response = await this.deductionRepository.getApprovals(params, refetch);

    return response;
  }
}